import React from 'react';
import _map from 'lodash/map';
import _size from 'lodash/size';

const conditionalNav = ['testimonial', 'faq'];

const NavBar = props => {
  const { nav = [], currentNavId, faqAndTestimonial = {}, setNavId } = props;
  return (
    <div className="store-pickup-navbar-container">
      <div className="store-pickup-navbar">
        {_map(nav, ({ label, id }) => {
          const isActive = currentNavId == id;
          if (conditionalNav.includes(id) && !_size(faqAndTestimonial[id])) {
            return null;
          }
          return (
            <a
              key={id}
              className={`store-pickup-options ${isActive ? 'active' : ''}`}
              onClick={() => {
                const node = document.getElementById(`${id}`);
                if (node) {
                  node.scrollIntoView({ behavior: 'smooth' });
                }
                setNavId(id);
              }}
            >
              {label}
              {isActive ? <div className="horizontalBar" /> : null}
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default NavBar;
